import { render, staticRenderFns } from "./Empty2.vue?vue&type=template&id=2df0e1c1&scoped=true"
import script from "./Empty2.vue?vue&type=script&lang=js"
export * from "./Empty2.vue?vue&type=script&lang=js"
import style0 from "./Empty2.vue?vue&type=style&index=0&id=2df0e1c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df0e1c1",
  null
  
)

export default component.exports